import dashboardIcon from "../../assets/svgs/menu-icons/DashboardIcon";
import transactionIcon from "../../assets/svgs/menu-icons/TransactionIcon";
import servicesIcon from "../../assets/svgs/menu-icons/ServicesIcon";
import apiprovidersIcon from "../../assets/svgs/menu-icons/APIproviderIcon";
import usersIcon from "../../assets/svgs/menu-icons/UsersIcon";
import { getFirstSegment } from "../../utils/utils";
import IncomingRequestsIcon from "../../assets/svgs/menu-icons/IncomingRequestsIcon";
import eventsIcon from "../../assets/svgs/menu-icons/eventsIcon";
import { isAdmin, isVendor } from "../../helpers/config";
/* import alertsIcon from "../../assets/svgs/menu-icons/AlertsIcon";
import administratorsIcon from "../../assets/svgs/menu-icons/AdministratorsIcon";
import securityIcon from "../../assets/svgs/menu-icons/SecurityIcon";
 */
export const MENU_KEYS = {
  DASHBOARD: "overview",
  TRANSACTIONS: "transactions",
  SERVICES: "services",
  APIPROVIDERS: "api-providers",
  USERS: "users",
  EVENTS: "events",
  EVENTVENDORS: "event-vendors",
  INCOMING_REQUESTS: "incoming-requests",
/*   Alerts: "Alerts",
  Administrators: "Administrators",
  Security: "Security", */
};

export const dashboardMenus = (selected) => {
  const _buildIcon = (key, menuIcon) => {
    const selectedMenu = selected?.toLowerCase();
    const selectedList = [selectedMenu, getFirstSegment(selectedMenu)];
    return menuIcon({ fill: selectedList.includes(key?.toLowerCase()) ? "#9747ff" : undefined });
  };

  const {
    DASHBOARD,
    TRANSACTIONS,
    SERVICES,
    APIPROVIDERS,
    USERS,
    EVENTS,
    EVENTVENDORS,
    INCOMING_REQUESTS,
   /*  Alerts,
    Administrators,
    Security, */
  } = MENU_KEYS;

  // Define all menu items
  const allMenuItems = [
    {
      key: DASHBOARD,
      label: "Dashboard",
      icon: _buildIcon(DASHBOARD, dashboardIcon),
      children: null,
    },
    {
      key: TRANSACTIONS,
      label: "Transactions",
      icon: _buildIcon(TRANSACTIONS, transactionIcon),
      children: null,
    },
    {
      key: SERVICES,
      label: "Services",
      icon: _buildIcon(SERVICES, servicesIcon),
      children: null,
    },
    {
      key: APIPROVIDERS,
      label: "API Providers",
      icon: _buildIcon(APIPROVIDERS, apiprovidersIcon),
      children: null,
    },
    {
      key: USERS,
      label: "Users",
      icon: _buildIcon(USERS, usersIcon),
      children: null,
    },
    {
      key: EVENTS,
      label: "Events",
      icon: _buildIcon(EVENTS, eventsIcon),
      children: null,
    },
    {
      key: EVENTVENDORS,
      label: "Event Vendors",
      icon: _buildIcon(EVENTVENDORS, eventsIcon),
      children: null,
    },
    {
      key: INCOMING_REQUESTS,
      label: "Incoming Requests",
      icon: _buildIcon(INCOMING_REQUESTS, IncomingRequestsIcon),
      children: null,
    },
 /*    {
      key: Alerts,
      label: "Alerts",
      icon: _buildIcon(Alerts, alertsIcon),
      children: null,
    },
    {
      key: Administrators,
      label: "Administrators",
      icon: _buildIcon(Administrators, administratorsIcon),
      children: null,
    },
    {
      key: Security,
      label: "Security",
      icon: _buildIcon(Security, securityIcon),
      children: null,
    }, */
  ];

  // Return different menu items based on user type
  if (isVendor) {
    // Vendors only see Event Vendors
    return allMenuItems.filter(item => item.key === EVENTVENDORS);
  }

  // Admins see all menu items
  return allMenuItems;
};